import axios from '../../../core/services/axios';

// eslint-disable-next-line import/prefer-default-export
export const getRoles = () => axios.get('/api/roles');
